<template>
    <dialog-template v-bind="$attrs"
        @update:visible="handleVisible"
        :visible="true"
        :width="'918px'">
        <div class="fx-v-center" slot="title">
            <h1 class="fs-16 fw-600 color-333">重复数据处理（{{ dataIndex + 1 }}/{{ repeatData.length }}）</h1>
            <span class="color-999 fs-12">有{{ repeatData.length }}条重复数据需手动处理</span>
        </div>
        <h2 class="color-333 fs-14 fw-600 lh-30 align-c">请选择优先保留哪一种数据</h2>
        <el-table :data="curTableData"
            :row-class-name="handleRowClassName"
            @row-click="handleRowClick">
            <el-table-column
                label="选择"
                width="50">
                <template v-slot="{ row, $index }">
                    <el-radio v-model="isSelected" :label="$index" @change="radioChange(row)"></el-radio>
                </template>
            </el-table-column>
            <el-table-column
                label="数据来源"
                width="90">
                <template v-slot="{ $index }">
                    <p v-if="$index === 0">导入数据</p>
                    <p v-else>原店铺数据</p>
                </template>
            </el-table-column>
            <el-table-column
                label="会员姓名"
                width="180">
                <template v-slot="{ row }">
                    <user-info :userInfo="{
                        avatar: get(row, 'user.avatar'),
                        nickname: get(row, 'user.nickname'),
                        realname: get(row, 'realname') || get(row, 'name'),
                        gender: get(row, 'user.gender')
                    }" />
                </template>
            </el-table-column>
            <el-table-column 
                label="手机号"
                width="110"
                align='center'>
                <template v-slot="{ row }">
                    <p>{{ row.phone || '-' }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="生日"
                width="110"
                align='center'>
                <template v-slot="{ row }">
                    <p>{{ row.birthday || '-' }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="余额(元)"
                width="94"
                align="center">
                <template v-slot="{ row }">
                    <p>{{ row.balance || '-' }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="积分"
                width="90"
                align="center">
                <template v-slot="{ row }">
                    <p>{{ row.point || '-' }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="会员卡号"
                width="160"
                align="center">
                <template v-slot="{ row }">
                    <p>{{ row.card_code || '-' }}</p>
                </template>
            </el-table-column>
            <el-table-column width="10" />
        </el-table>
        <div class="select-result mt-12 fx-v-center" v-if="curData != null">
            <p class="header-title ml-8">导入预览效果</p>
            <div class="fx-v-center table">
                <user-info :userInfo="{
                    avatar: get(curData, 'user.avatar'),
                    nickname: get(curData, 'user.nickname'),
                    realname: get(curData, 'realname') || get(curData, 'name'),
                    gender: get(curData, 'user.gender')
                }" />
                <span class="align-c">{{ curData.phone || '-' }}</span>
                <span class="align-c">{{ curData.birthday || '-' }}</span>
                <span class="align-c">{{ curData.balance || '-' }}</span>
                <span class="align-c">{{ curData.point || '-' }}</span>
                <span class="align-c">{{ curData.card_code || '-' }}</span>
            </div>
        </div>
        <p class="mt-20 color-333 align-c">本次选择应用于所有数据</p>
        <div class="fx-center" slot="footer">
            <el-button type="primary" size="medium" :loading="isConfirmLoading" :disabled="!isCanConfirm" @click="confirm()">确认</el-button>
            <el-button size="medium" @click="dataIndex ++" :disabled="dataIndex === repeatData.length - 1">下一条</el-button>
            <el-button size="medium" @click="dataIndex --" :disabled="dataIndex === 0">上一条</el-button>
        </div>
    </dialog-template>
</template>

<script lang="tsx">
import { createComponent, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
import clone from 'lodash/cloneDeep'
import { openWarning } from '@/utils/system.tsx'
import get from 'lodash/get'

export default createComponent({
    props: {
        repeatData: {
            type: Array,
            default: () => []
        }
    },

    setup: (props, ctx) => {
        const isSelected = ref<number>()
        const dataIndex = ref(0)
        const isHandleAll = ref(false)
        const isConfirmLoading = ref(false)

        const isCanConfirm = computed(() => {
            return isSelected.value != null
        })

        const curTableData = computed(() => {
            console.log(props.repeatData, dataIndex.value)
            const item = props.repeatData[dataIndex.value] as any
            if (item == null) {
                return []
            }

            const arr = new Array(2)
            arr[0] = item.imported_member
            arr[1] = item.existed_member

            return arr
        })

        const curData = computed(() => {
            if (isSelected.value == null) {
                return
            }
            return curTableData.value[isSelected.value]
        })

        function handleVisible() {
            openWarning({
                title: '系统提示',
                type: 'danger',
                render() {
                    return (
                        <div class="align-c">
                            <h2 class="fs-16 fw-600 lh-20 color-333">确认放弃处理重复数据吗？</h2>
                            <p class="fs-12 lh-16 color-999">此部分数据将无法导入系统</p>
                        </div>
                    )
                }
            }).then(() => {
                confirm(1)
            }).catch(() => {})
        }

        function handleRowClassName({ row, rowIndex }) {
            row.index = rowIndex
        }

        function handleRowClick(row, column, event) {
            isSelected.value = row.index
        }

        async function confirm(val = isSelected.value) {
            try {
                isConfirmLoading.value = true
                await ctx.emit('confirm', val)
            } catch (e) {}
            finally {
                isConfirmLoading.value = false
                ctx.emit('update:visible', false)
                ctx.emit('close')
            }
        }

        return {
            isSelected,
            isHandleAll,
            isCanConfirm,
            isConfirmLoading,
            dataIndex,
            curData,
            curTableData,
            get,
            handleVisible,
            handleRowClassName,
            handleRowClick,
            confirm
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-radio__label {
    display: none;
}

::v-deep .el-table tr {
    cursor: pointer;
}

.select-result {
    .table {
        height: 44px;
        line-height: 44px;
        padding: 0 10px 0 20px;
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        margin-left: 38px;
        color: #333;

        &:hover {
            background-color: #f7f7f7;
        }

        ::v-deep .user-info {
            width: 154px !important;
            margin-right: 16px;
        }

        span {
            display: inline-block;

            &:nth-child(2),
            &:nth-child(3) {
                width: 110px;
                // padding-left: 5px;
            }
            &:nth-child(4) {
                width: 94px;
            }
            &:nth-child(5) {
                width: 90px;
            }
            &:nth-child(6) {
                width: 160px;
            }
        }
    }
}
</style>
